module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emailAddress":"Email Address"},"es":{"emailAddress":"Dirección de correo electrónico"},"sw":{"emailAddress":"Barua Pepe"}}')
  delete Component.options._Ctor
}
